import "../styles/Main.css";
import logo from '../images/logos/Boughton-ShieldsCreationsBanner.jpg';

function main() {
    return (
        <div className="main">
            <img src={logo} alt="Boughton-Shields Creations Logo" class="center" id="mainLogo"/>
            <div id="tagLine">
                <h1 id="progammer"> Progammer </h1>
                <h1 class="line"> | </h1>
                <h1 id="maker"> Maker </h1>
                <h1 class="line"> | </h1>
                <h1 id="photographer"> Photographer </h1>
            </div>
        </div>
    )
}

export default main;